import { DateTime } from 'luxon';

import { parseDateTime } from '../../parse';

export interface MappedAlert {
  beginTime: DateTime;
  endTime: DateTime | null;
  parameters: {
    expiresInHours: number;
    [key: string]: any;
  };
  [key: string]: any;
}

export function mapAlertWithExpiration(alert: {
  beginTime: string;
  endTime?: string | null;
  parameters: Record<string, any>;
  [key: string]: any;
}): MappedAlert {
  const beginTime = parseDateTime(alert.beginTime);
  const endTime = alert.endTime ? parseDateTime(alert.endTime) : null;

  const expirationTime = beginTime.plus({ hours: 48 });
  const expiresInHours = Math.max(1, Math.ceil(expirationTime.diffNow('hours').hours));

  return {
    ...alert,
    beginTime,
    endTime,
    parameters: {
      ...alert.parameters,
      expiresInHours,
    },
  };
}
